const updateOrderItemDocument = ({
  orderItems,
  oidIndex,
  sku,
  content,
  target,
}) => {
  const currentOrderItems = orderItems
  currentOrderItems[`${oidIndex(sku)}`].documents = [
    ...(currentOrderItems[`${oidIndex(sku)}`].documents || []).filter(x => x.id !== target.id),
    { id: target.id, type: content.type },
  ]
}

export default updateOrderItemDocument
